import { C as CosmosBottomSheet$1, d as defineCustomElement$1 } from './p-C_UAOMqO.js';

const CosmosBottomSheet = CosmosBottomSheet$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosBottomSheet, defineCustomElement };
